import { render, staticRenderFns } from "./CurriculumSyllabusHeader.vue?vue&type=template&id=12ed0e28&scoped=true&"
import script from "./CurriculumSyllabusHeader.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusHeader.vue?vue&type=style&index=0&id=12ed0e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed0e28",
  null
  
)

export default component.exports